import api from '@/services/api.service';

function unwrap<T>(res: unknown): T {
  const body = (res as { data?: unknown })?.data ?? res;
  return (body as { data?: T })?.data ?? (body as T);
}

export interface DisposalPreview {
  asset: { id: string; asset_code: string; asset_name: string; status: string };
  cost: number;
  ad: number;
  nbv: number;
  proceeds: number;
  gain_loss: number;
}

export interface DisposalEvent {
  id: string;
  company_id: string;
  disposal_number: string;
  asset_id: string;
  disposal_type: string;
  disposal_date: string;
  purchase_value_at_disposal: number | null;
  accumulated_dep_at_disposal: number | null;
  book_value_at_disposal: number | null;
  proceeds: number | null;
  gain_loss: number | null;
  notes: string | null;
  journal_voucher_id: string | null;
  created_at?: string;
}

const assetDisposalService = {
  async preview(body: { asset_id: string; proceeds?: number }): Promise<DisposalPreview> {
    const res = await api.post('/asset-disposal/preview', body);
    return unwrap(res);
  },
  async execute(body: {
    asset_id: string;
    disposal_type: 'sale' | 'scrap' | 'write_off';
    disposal_date: string;
    proceeds?: number;
    notes?: string | null;
    accumulated_depreciation_account_id: string;
    asset_cost_account_id: string;
    proceeds_account_id: string;
    gain_loss_account_id: string;
  }): Promise<{
    event: DisposalEvent;
    journal_voucher_id: string;
    journal_voucher_number: string;
    financial: { cost: number; ad: number; nbv: number; proceeds: number; gain_loss: number };
  }> {
    const res = await api.post('/asset-disposal/execute', body);
    return unwrap(res);
  },
  async listEvents(): Promise<DisposalEvent[]> {
    const res = await api.get('/asset-disposal/events');
    const data = unwrap<DisposalEvent[]>(res);
    return Array.isArray(data) ? data : [];
  },
};

export default assetDisposalService;
